<template>
    <div>
        <div class="tabs_content">
            <ul>
                <li class="active">订货汇总</li>
                <li @click="orderjump(2)">订单统计</li>
                <li @click="orderjump(3)">分类统计</li>
                <li @click="orderjump(4)">品牌统计</li>
            </ul>
        </div>
        <div class="summary_search_content">
            <div class="summary_search_left">
                <div class="order_search_list">
                    <DatePicker type="date" format="yyyy-MM-dd" :value="stardatetiem" placeholder="开始时间" :clearable="false" @on-change="starChange" style="width: 148px;"></DatePicker>
                    <span class="order_search_spacer">~</span>
                    <DatePicker type="date" format="yyyy-MM-dd" :value="enddatetiem" placeholder="结束时间" :clearable="false" @on-change="endChange" style="width: 148px;"></DatePicker>
                </div>
                <div class="export_excel_btn" @click="orderdownclick"><i class="icon iconfont icon-excel"></i>导出Excel</div>
            </div>
            <div class="summary_search_right">
                <div class="summary_search_info">
                    <span>合计数量：</span>
                    <b>{{goodstjsum.ordernum}}</b>
                    <Poptip trigger="hover" content="统计时间内下单商品总数量（不含已取消）">
                        <Icon type="md-help-circle" class="summary_search_tips" />
                    </Poptip>
                </div>
                <div class="summary_search_info">
                    <span>合计金额：</span>
                    <b>{{goodstjsum.ordersubtotal}}</b>
                    <Poptip trigger="hover" placement="top-end" content="统计时间内订购商品总金额（商品促销及订单优惠/特价按商品优惠后价格计算）">
                        <Icon type="md-help-circle" class="summary_search_tips" />
                    </Poptip>
                </div>
            </div>
        </div>
        <div class="ordergoods_list_content">
            <Table
                border
                ref="selection"
                :loading="tloading"
                :columns="thead"
                :data="goodslist"></Table>
        </div>
        <!-- 分页 -->
        <div class="page_content">
            <Page
                :total="pagetotal"
                :current="pagecurrent"
                :page-size="pagesize"
                :page-size-opts="pagesizeopts"
                show-total
                show-sizer
                show-elevator
                @on-change="pageChange"
                @on-page-size-change="pageSizeChange" />
        </div>
    </div>
</template>

<script>
import api from '@/request/api.js'
import {add, min, unitChange, numBlur} from '@/assets/js/addcart.js'
export default {
    data() {
        return {
            tloading: false, // 表格加载中
            outstock: 0, // 是否允许超库存购买 1 允许客户购买下单
            banorder: {}, // 是否禁止下单 error msg
            stardatetiem: '', // 开始时间
            enddatetiem: '', // 结束时间
            goodstjsum: {
                ordernum: 0, // 合计数量
                ordersubtotal: 0, // 合计金额
            },
            thead: [ // 表格头部
                {
                    type: 'index',
                    width: 40,
                    align: 'center'
                },
                {
                    width: 240,
                    title: '商品',
                    key: 'goods',
                    render: (h, params) => {
                        console.log(params.row)
                        return h('div', // 商品
                                    [
                                        h('div', // 商品图片
                                            {
                                                class: 'shoppingcart_goods_left',
                                                style: {
                                                    backgroundImage: params.row.is_del == 1 || params.row.is_show == 2 || params.row.isolate == 1 ? '' : 'url(' + params.row.img + ')',
                                                },
                                                on: {
                                                    click: () => {
                                                        this.goto(params.row.goodsid, params.row.is_del, params.row.is_show, params.row.isolate)
                                                    }
                                                },
                                            },
                                            params.row.is_del == 1 || params.row.is_show == 2 || params.row.isolate == 1 ? '失效' : ''
                                        ),
                                        h('div', // 商品右侧信息
                                            {
                                                class: 'shoppingcart_goods_right'
                                            },
                                            [
                                                h('Poptip',
                                                    {
                                                        props: {
                                                            trigger: 'hover',
                                                            content: params.row.goodsname,
                                                        }
                                                    },
                                                    [
                                                        h('span', // 商品名称
                                                            {
                                                                class: 'shoppingcart_goods_name'
                                                            },
                                                            [
                                                                h('span', params.row.goodsname)
                                                            ]
                                                        ),
                                                    ]
                                                ),
                                                h('small', params.row.commcode), // 商品id
                                            ]
                                        ),
                                    ]
                                )
                    }
                },
                {
                    title: '规格',
                    key: 'gg_attrname'
                },
                {
                    title: '合计数量',
                    key: 'ordernum'
                },
                {
                    title: '合计金额',
                    key: 'ordersubtotal'
                },
                {
                    title: '平均价格',
                    key: 'avgcost'
                },
                {
                    title: '数量占比',
                    key: 'numbili',
                    render: (h, params) => {
                        return h('span', params.row.numbili + '%')
                    }
                },
                {
                    title: '金额占比',
                    key: 'costbili',
                    render: (h, params) => {
                        return h('span', params.row.costbili + '%')
                    }
                },
                {
                    title: '再次订购',
                    width: 192,
                    key: 'onegoodssub',
                    render: (h, params) => {
                        if (params.row.stock < params.row.minordernum && this.outstock <= 0) {
                            return h('span', {style: {textAlign: 'center', display: 'block', color: '#999'}}, '缺货')
                        }
                        if (params.row.stock >= params.row.minordernum || this.outstock == 1) {
                            return h('div',
                                        {
                                            class: 'goods_list_gather_box',
                                            style: {
                                                justifyContent: 'center'
                                            }
                                        },
                                        [
                                            h('div', {class: 'goods_list_num_content'},
                                                [
                                                    h('div', {class: 'goods_list_num'},
                                                        [
                                                            h('span',
                                                                {
                                                                    on: {
                                                                        click: () => {
                                                                            this.minBtn(params.row, params.row.minorderunit, params.row.minordernum, params.row.matrixing, params.index)
                                                                        }
                                                                    }
                                                                },
                                                                '-'
                                                            ),
                                                            h('div', {class: 'goodsnum_select'},
                                                                [
                                                                    h('InputNumber',
                                                                        {
                                                                            class: 'goodsnum',
                                                                            props: {
                                                                                min: 0,
                                                                                value: params.row.num
                                                                            },
                                                                            on: {
                                                                                'on-change': (e) => {
                                                                                    params.row.num = e
                                                                                },
                                                                                'on-blur': () => {
                                                                                    this.goodsnumBlur (params.row, params.row.cxinfo, params.row.stock, params.row.minorderunit, params.row.minordernum, params.row.matrixing, params.row.maxunit, params.row.unit, params.index)
                                                                                }
                                                                            }
                                                                        },
                                                                    ),
                                                                    h('i', {class: 'icon iconfont icon-xingzhuangjiehe', style: {display: params.row.carcheck ? 'block' : 'none'}}),
                                                                ]
                                                            ),
                                                            h('span', 
                                                                {
                                                                    on: {
                                                                        click: () => {
                                                                            this.addBtn(params.row, params.row.cxinfo, params.row.stock, params.row.minorderunit, params.row.minordernum, params.row.matrixing, params.row.maxunit, params.row.unit, params.index)
                                                                        }
                                                                    }
                                                                },
                                                                '+'
                                                            ),
                                                        ]
                                                    ),
                                                    h('Tooltip',
                                                        {
                                                            props: {
                                                                content: params.row.unitshow ?  params.row.maxunit :  params.row.unit,
                                                                theme: 'light',
                                                                placement: 'top'
                                                            }
                                                        },
                                                        [
                                                            h('div',
                                                                {
                                                                    class: 'goods_list_unit',
                                                                    style: {
                                                                        width: params.row.doubleunit == 1 || params.row.minorderunit == 'maxunit' ? '23px' : ''
                                                                    },
                                                                    on: {
                                                                        click: () => {
                                                                            this.unitChange(params.row, params.row.cxinfo, params.row.stock, params.row.minorderunit, params.row.minordernum, params.row.matrixing, params.row.maxunit, params.row.unit, params.row.doubleunit, params.index)
                                                                        }
                                                                    },
                                                                },
                                                                [
                                                                    h('span', params.row.unitshow ? params.row.maxunit : params.row.unit),
                                                                    h('i',
                                                                        {
                                                                            class: 'icon iconfont icon-xialazhankai',
                                                                            style: {
                                                                                display: params.row.doubleunit == 1 || params.row.minorderunit == 'maxunit' ? 'none' : 'block'
                                                                            }
                                                                        }
                                                                    )
                                                                ],
                                                            )
                                                        ],
                                                    ),
                                                ]
                                            ),
                                            h('div',
                                                {
                                                    class: 'goods_list_gwcbtn',
                                                    style: {
                                                        marginLeft: '10px'
                                                    },
                                                    on: {
                                                        click: () => {
                                                            this.addGoods(params.row)
                                                        }
                                                    }
                                                },
                                                [
                                                    h('i', {class: 'icon iconfont icon-dianliang'})
                                                ]
                                            ),
                                        ]
                                    )
                        }
                    }
                },
            ],
            goodslist: [], // 表格列表
            pagetotal: 0, // 分页总数
            pagesize: 30, // 分页每页条数
            pagesizeopts: [30, 60, 90], // 分页每页条数切换的配置[4, 8, 16][30, 60, 90]
            pagecurrent: 1, // 当前分页
        }
    },
    methods: {
        getInfo () { // 获取信息
            if (!this.$store.state.openmall) {
                this.tloading = true
                this.http.post(api.statisticgoods,
                    {
                        starttime: this.stardatetiem,
                        endtime: this.enddatetiem,
                        page: this.pagecurrent,
                        pagesize: this.pagesize,
                    }
                )
                .then(response => {
                    // console.log(response.data.msg)
                    console.log(response.data.msg.goodstj)
                    for (var i = 0; i < response.data.msg.goodstj.length; i++) {
                        response.data.msg.goodstj[i].unitshow = false
                        response.data.msg.goodstj[i].num = 0
                        // 是否加入购物车图标
                        response.data.msg.goodstj[i].carcheck = false
                    }
    
                    for (var i = 0; i < this.$store.state.shopcartlist.length; i++) {
                        for (var j = 0; j < response.data.msg.goodstj.length; j++) {
                            if (this.$store.state.shopcartlist[i].gg_id == response.data.msg.goodstj[j].goodsdetid) {
                                response.data.msg.goodstj[j].unitshow = this.$store.state.shopcartlist[i].unitshow
                                response.data.msg.goodstj[j].num = this.$store.state.shopcartlist[i].num
                                // 是否加入购物车图标
                                response.data.msg.goodstj[j].carcheck = true
                            }
                        }
                    }
                    this.goodslist = response.data.msg.goodstj
                    this.goodstjsum = response.data.msg.goodstjsum
                    this.pagetotal = response.data.msg.goodstj_pagecontent.num
                    // 是否禁止购买
                    this.banorder = response.data.msg.orderlimit
                    // 是否允许超库存购买
                    this.outstock = response.data.msg.depository_dinghuominus
                    this.tloading = false
                })
                .catch(error => {
                    console.log(error);
                })
            }
        },
        orderjump (sign) { // 跳转链接
            let link
            if (sign == 1) {
                link = '/OrderGoodSummary'
            } else if (sign == 2) {
                link = '/OrderStatistics'
            } else if (sign == 3) {
                link = '/ClassifyStatistics'
            } else if (sign == 4) {
                link = '/BrandStatistics'
            }
            this.$router.push(link)
        },
        starChange (e) { // 搜索订单开始时间
            let yes = new Date(e) > new Date(this.enddatetiem)

            if (yes) {
                this.$Message.error('开始时间不能大于结束时间')
                this.stardatetiem = ''
                setTimeout(() => { this.stardatetiem = this.getThirtyDateTime() }, 0)
            } else {
                this.stardatetiem = e
                this.pagecurrent = 1
                this.getInfo()
            }
        },
        endChange (e) { // 搜索订单结束时间
            let yes = new Date(e) < new Date(this.stardatetiem)
            
            if (yes) {
                this.$Message.error('结束时间不能小于开始时间')
                this.enddatetiem = ''
                setTimeout(() => { this.enddatetiem = this.getDateTime() }, 0)
            } else {
                this.enddatetiem = e
                this.pagecurrent = 1
                this.getInfo()
            }
        },
        orderdownclick () { // 导出表格
            window.open(this.getWebsite() + api.statgoodsupload + '&shopid=' + this.getCookie('cook_ShopId') + '&cus_uid=' + this.getCookie('cook_cus_uid') + '&cus_pwd=' + this.getCookie('cook_cus_pwd') + '&starttime=' + this.stardatetiem + '&endtime=' + this.enddatetiem + '&op=export_csv')
        },
        pageChange (e) { // 分页翻页改变
            this.pagecurrent = e
            this.getInfo()
        },
        pageSizeChange (e) { // 分页每页条数改变
            this.pagecurrent = 1
            this.pagesize = e
            this.getInfo()
        },
        goto (id, del, show, isolate) { // 跳转商品详情页
            if (del != 1 && show != 2 && isolate != 1) {
                this.$router.push({
                    name: '商品详情',
                    params: {
                        id: id
                    }
                })
            } else {
                this.$Message.error('商品已失效')
            }
        },
        minBtn (item, minorderunit, minordernum, matrixing, index) { // 减少购买数量
            this.goodslist[index].num = min(item, minorderunit, minordernum, matrixing)
        },
        addBtn (item, cxinfo, stock, minorderunit, minordernum, matrixing, maxunit, unit, index) { // 增加购买数量
            this.goodslist[index].num = add(item, cxinfo, stock, minorderunit, minordernum, matrixing, maxunit, unit, this.outstock)
        },
        unitChange (item, cxinfo, stock, minorderunit, minordernum, matrixing, maxunit, unit, doubleunit, index) { // 切换大小单位
            let params = unitChange (item, cxinfo, stock, minorderunit, minordernum, matrixing, maxunit, unit, doubleunit, this.outstock)
            this.goodslist[index].unitshow = params.unitshows
            this.goodslist[index].num = params.nums
        },
        goodsnumBlur (item, cxinfo, stock, minorderunit, minordernum, matrixing, maxunit, unit, index) { // 输入数量
            this.goodslist[index].num = numBlur(item, cxinfo, stock, minorderunit, minordernum, matrixing, maxunit, unit, this.outstock)
        },
        addGoods (item) { // 添加购物车
            if (!this.banorder.error) { // 判断orderlimit.error是否限制下单
                this.goodscheck(item)
            } else {
                this.$Message.warning(this.banorder.msg)
            }
        },
        goodscheck (item) { // 检测是否可以添加购物车
            if (item.num > 0) {
                let newItem = [] // 添加到购物车的字段
                newItem.push({
                    gg_id: item.goodsdetid, // 规格id
                    id: item.goodsid, // 商品id
                    num: item.num, // 商品数量
                    unitshow: item.unitshow, // 大小单位切换 false 小 true 大
                    remarks: '', // 备注信息
                })

                this.http.post(api.goodscheck,
                    {
                        gid: newItem[0].gg_id,
                        goodnum: newItem[0].num,
                        unitshow: newItem[0].unitshow,
                    }
                )
                .then(response => {
                    console.log(response.data.msg)
                    // 添加id购物车到缓存
                    this.$store.dispatch('addShopCartList', newItem)
                    // 添加成功提示
                    this.$Message.success('添加购物车成功')
                    item.carcheck = true
                })
                .catch(error => {
                    this.$Message.warning(error);
                })
            } else {
                this.$Message.warning('购买数量不能为0');
            }
        }
    },
    created () {
        let stardate, endate
        stardate = this.getThirtyDateTime().split(' ')
        endate = this.getDateTime().split(' ')
        this.stardatetiem = stardate[0]
        this.enddatetiem = endate[0]
        this.getInfo()
    }
}
</script>

<style scoped>

.ordergoods_list_content {
    padding: 20px 20px 0;
}

</style>


// WEBPACK FOOTER //
// src/components/views/statistics/ordergoodsummary.vue